module.exports = __webpack_public_path__ + "/public/images/e33c878c8e1b176d439484ca0a094ec4.png";